import { Link } from "react-router-dom";
import { animeRoles } from "@/mocks/roles";

const hotTags = ["萌系", "冷系", "元气", "治愈", "优雅", "傲娇", "猫娘", "双马尾", "银发", "和服"];

export default function HomeSidebar() {
  const recommended = [...animeRoles].sort((a, b) => b.popularity - a.popularity).slice(0, 4);

  const stats = [
    { label: "收录角色", value: "560+", icon: "ri-user-heart-line" },
    { label: "资讯文章", value: "1,240+", icon: "ri-article-line" },
    { label: "社区话题", value: "3,800+", icon: "ri-chat-smile-2-line" }
  ];

  return (
    <aside className="space-y-6">
      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="mb-4 flex items-center gap-2 font-heading text-base text-foreground-950">
          <i className="ri-bar-chart-box-line text-accent-500"></i>
          网站速览
        </h3>
        <div className="space-y-3">
          {stats.map((s) => (
            <div key={s.label} className="flex items-center justify-between rounded-md bg-background-100 px-3 py-2.5">
              <span className="flex items-center gap-2 text-sm text-foreground-700">
                <i className={`${s.icon} text-secondary-500`}></i>
                {s.label}
              </span>
              <span className="font-heading text-lg text-primary-600">{s.value}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="mb-4 flex items-center gap-2 font-heading text-base text-foreground-950">
          <i className="ri-heart-3-line text-primary-500"></i>
          热门角色推荐
        </h3>
        <div className="space-y-2">
          {recommended.map((role, i) => (
            <Link
              key={role.id}
              to={`/role/${role.id}`}
              className="group flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-100"
            >
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-bold text-accent-700">
                {i + 1}
              </span>
              <div className="h-12 w-12 shrink-0 overflow-hidden rounded-md bg-background-100">
                <img src={role.cover} alt={role.name} className="h-full w-full object-top" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                  {role.name}
                </p>
                <p className="truncate text-xs text-foreground-500">{role.work}</p>
              </div>
              <span className="text-xs text-foreground-400">{role.popularity}</span>
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-5">
        <h3 className="mb-4 flex items-center gap-2 font-heading text-base text-foreground-950">
          <i className="ri-price-tag-3-line text-secondary-500"></i>
          热门标签
        </h3>
        <div className="flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to={`/roles?tag=${encodeURIComponent(tag)}`}
              className="rounded-full border border-background-300 bg-background-100 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
        <h3 className="mb-2 flex items-center gap-2 font-heading text-base text-foreground-950">
          <i className="ri-megaphone-line text-accent-600"></i>
          加入社区
        </h3>
        <p className="text-sm leading-relaxed text-foreground-700">
          和千万二次元同好一起聊角色、追新番、分享你的本命故事。
        </p>
        <Link
          to="/community"
          className="mt-4 inline-flex items-center gap-1 rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
        >
          进入社区
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </aside>
  );
}